import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    top: -1,
    height: 36,
    marginRight: `${theme.spacing(2)}px !important`
  }
}))

export {
  useStyles
}
